var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ProjectWorkspaceDocumentComparisonsApi from '~/api/projects-workspace/document_comparisons/index.js';
import { transformMetaData } from '~/utils/updateMetadata';
export default function getComparisons(projectId) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!projectId) {
            return [];
        }
        const updateDataKeys = (folderDetail) => folderDetail.map(comparison => (Object.assign(Object.assign({}, comparison), { documents: comparison.documents.map(c => transformMetaData(c)) })));
        const folderDetail = yield ProjectWorkspaceDocumentComparisonsApi.getById(projectId);
        if (!(folderDetail === null || folderDetail === void 0 ? void 0 : folderDetail.length)) {
            return [];
        }
        return updateDataKeys(folderDetail);
    });
}
